import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { ToolbarModule } from 'primeng/toolbar';
import { Table, TableModule } from 'primeng/table';
import { Router, RouterModule } from '@angular/router';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { CardModule } from 'primeng/card';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ContextMenuModule } from 'primeng/contextmenu';
import { DividerModule } from 'primeng/divider';
import { FieldsetModule } from 'primeng/fieldset';
import { FluidModule } from 'primeng/fluid';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputNumberModule } from 'primeng/inputnumber';
import { MessageModule } from 'primeng/message';
import { PanelModule } from 'primeng/panel';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { RadioButtonModule } from 'primeng/radiobutton';
import { RatingModule } from 'primeng/rating';
import { RippleModule } from 'primeng/ripple';
import { SelectModule } from 'primeng/select';
import { SplitterModule } from 'primeng/splitter';
import { TagModule } from 'primeng/tag';
import { TextareaModule } from 'primeng/textarea';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { InMemoryStorageService } from '../services/in-memory-storage.service';
import { DatePickerModule } from 'primeng/datepicker';
import { lastValueFrom, Subject, takeUntil } from 'rxjs';
import { OrderdetailsComponent } from '../orderdetails/orderdetails.component';
import { UserRole } from '../auth/roles.enum';
import { RoleAccessService } from '../auth/role-access.service';
import { LoaderService } from '../services/loader.service';

@Component({
    selector: 'app-team-details',
    imports: [
        DatePickerModule,
        ProgressSpinnerModule,
        ToastModule,
        FluidModule,
        DividerModule,
        MessageModule,
        RouterModule,
        FormsModule,
        AutoCompleteModule,
        CommonModule,
        TableModule,
        FieldsetModule,
        PanelModule,
        SplitterModule,
        ButtonModule,
        CardModule,
        ContextMenuModule,
        RippleModule,
        ToolbarModule,
        RatingModule,
        InputTextModule,
        TextareaModule,
        SelectModule,
        RadioButtonModule,
        InputNumberModule,
        DialogModule,
        TagModule,
        InputIconModule,
        IconFieldModule,
        ConfirmDialogModule
    ],
    templateUrl: './team-details.component.html',
    styleUrls: ['./team-details.component.scss'],
    providers: [MessageService]
})
export class TeamDetailsComponent implements OnInit, OnDestroy {
    calendarValue: any;
    isReadOnly = false;
    userRoles: UserRole[] = [];
    @ViewChild('assignTaskButton') assignTaskButton!: ElementRef<HTMLButtonElement>;
    refreshOrders() {
        this.loadTaskProgress();
    }

   


    taskProgressList: any[] = [];
    headerPanelOpen: boolean = true;
    userAssignmentsPanelOpen: boolean = true;
    isEditingTargets: boolean = false;

    selectedTask: any = null;
    private destroy$ = new Subject<void>();
    task: any = {
        target_id: '',
        teamId: '',
        assignedBy: '',
        targetType: '',
        targetValue: 0,
        startDate: '',
        endDate: '',
        comment: ''
    };

    allUsers: any[] = [];
    selectedUser: any = null;
    showTaskForm = true;

    filteredUsers: any[] = [];
    userNamesOnly: string[] = [];
    filteredUserNames: string[] = [];
    selectedUserName: string = '';

    taskProgress = {
        targetValue: null,
        userName: '',
        userId: null,
        status: 'ACTIVE',
        updatedAt: new Date().toISOString(),
        managerId: 1,
        startDate: '',
        endDate: '',
        comments: '',
     
        flag: 10,
        company: '',
        division: ''
    };

    constructor(
        private router: Router,
        private http: HttpClient,
        private messageService: MessageService,
        private inmemoryStorageService: InMemoryStorageService,
        private roleAccessService: RoleAccessService,
        private loaderService: LoaderService
    ) {
    
    }
    divisionId: string = '';
    companyId: string = '';

   


    fetchSalesPersonUsers() {
        //  const divisionId = this.inmemoryStorageService.get('division') || '';
        this.http
            .get<any[]>(`${environment.authApiUrl}users-by-role-group?roleGroupName=sales_person_group`)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (data) => {
                    // Only save users whose division matches the current divisionId
                    this.allUsers = data
                        .filter((user) => user.division === this.divisionId)
                        .map((user) => ({
                            id: user.id,
                            userName: user.userName,
                            company: user.company,
                            division: user.division
                        }));

                    this.inmemoryStorageService.set('allUsers', JSON.stringify(this.allUsers));
                    console.log('Fetched users by role group (filtered by division):', this.allUsers);
                },
                error: (err) => {
                    console.error('Failed to fetch users by role group:', err);
                },
                complete: () => {
                    console.log('User fetch subscription completed.');
                }
            });
    }
    

    ngOnInit() {
          this.userRoles = JSON.parse(localStorage.getItem('roleGroup') || '[]') as UserRole[];
                console.log('UserRoles:', this.userRoles);
        
                this.isReadOnly = this.roleAccessService.isReadOnly(this.userRoles);
                console.log('IsReadOnly?', this.isReadOnly);
        
        this.divisionId = this.inmemoryStorageService.get('division') || '';
        this.companyId = this.inmemoryStorageService.get('company') || '';

        this.fetchSalesPersonUsers();
        const raw = this.inmemoryStorageService.get('allUsers');
        let data = [];
        this.taskProgress.division = this.divisionId;
        this.taskProgress.company = this.companyId;
        try {
            data = typeof raw === 'string' ? JSON.parse(raw) : raw;
        } catch (e) {
            console.error('Parsing error:', e);
        }

        if (Array.isArray(data)) {
            this.allUsers = data;
            this.userNamesOnly = data.map((u) => u.userName);
        }

        Promise.all([this.loadTaskProgress()]).then(() => {});
    }

    filterUserNames(event: any) {
        const query = event.query.toLowerCase();
        this.filteredUserNames = this.userNamesOnly.filter((name) => name.toLowerCase().includes(query));
    }

    filterUsers(event: any) {
        const query = event.query.toLowerCase();
        this.filteredUsers = this.allUsers.filter((user) => user.userName.toLowerCase().includes(query));
    }

    onUserSelected(event: any) {
        this.taskProgress.userName = event.value.userName;
        console.log('✅ Selected user:', event.value);

        this.taskProgress.userId = event.value.id;
        console.log('✅ Selected user:', this.taskProgress);
    }

    loadTaskProgress(): Promise<void> {
        this.loaderService.show('Loading team assignments...', 'please wait');
        return new Promise((resolve) => {
            this.http
                .get<any[]>(`${environment.apiUrl}taskprogress?company=${this.companyId}&division=${this.divisionId}`)
                .pipe(takeUntil(this.destroy$))
                .subscribe({
                    next: (data) => {
                        // Only add records where division matches current divisionId
                        this.taskProgressList = data
                            .filter((item) => item.division === this.divisionId)
                            .map((item) => ({
                                ...item,
                                flag: 20,
                                startDate: item.startDate ? new Date(item.startDate) : null,
                                endDate: item.endDate ? new Date(item.endDate) : null
                            }))
                            .reverse();

                        this.loaderService.hide();
                        resolve();
                    },
                    error: (err) => {
                        this.loaderService.hide();
                        this.messageService.add({
                            severity: 'error',
                            summary: 'Error',
                            detail: 'Failed to load task progress.',
                            life: 4000
                        });
                        resolve();
                    },
                    complete: () => {
                        console.log('Task progress fetch completed.');
                    }
                });
        });
    }
    deleteTaskProgress(row: any) {
        this.http
            .delete(`${environment.apiUrl}taskprogress/${row.id}`)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: () => {
                    // Remove the deleted row from the table
                    this.taskProgressList = this.taskProgressList.filter((item) => item.id !== row.id);
                    this.messageService.add({ severity: 'success', summary: 'Deleted', detail: 'Task progress deleted.', life: 4000 });
                },
                error: () => {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to delete task progress.', life: 4000 });
                },
                complete: () => {
                    console.log(`Delete request for taskProgress ID ${row.id} completed.`);
                }
            });
    }

    submitTeam() {
        this.loaderService.show('Updating task...', 'please wait');

        // Only include rows with flag 30
        const updatedMembers = this.taskProgressList.filter((member) => member.flag === 30);

        const updateRequests = updatedMembers.map((member: any) => {
            const progressPayload = {
                taskProgressId: member.taskProgressId,
                targetValue: member.targetValue,
                memberId: member.memberId,
                status: member.status, // Only send fields expected by API
                updatedAt: new Date().toISOString(),
                startDate: member.startDate,
                endDate: member.endDate,
                division: this.divisionId,
                company: this.companyId
            };
            return lastValueFrom(this.http.put(`${environment.apiUrl}taskprogress/${member.id}`, progressPayload));
        });

        Promise.all(updateRequests)
            .then(() => {
                this.loaderService.hide();
                this.messageService.add({
                    severity: 'success',
                    summary: 'Success',
                    detail: 'Updated team targets successfully!'
                    , life: 4000
                });
            })
            .catch(() => {
                this.loaderService.hide();
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to update some member progress.',
                    life: 4000
                });
            });
    }

    saveTask() {
        if (!this.task.target_id || !this.task.targetType || !this.task.targetValue || !this.task.startDate || !this.task.endDate || !this.task.teamId) {
            this.messageService.add({
                severity: 'warn',
                summary: 'Missing fields',
                detail: 'Please fill in all required fields.',
                life: 4000
            });
            return;
        }
    }

    // saveTaskProgress() {
    //   if (!this.taskProgress.userId || !this.taskProgress.task.taskId) {
    //     this.taskProgress.flag = 20;
    //     this.messageService.add({
    //       severity: 'warn',
    //       summary: 'Missing fields',
    //       detail: 'User ID and Task ID are required.'
    //     });
    //     return;
    //   }
    //   // this.resetForm();
    //   // Set flag to 20 for new assignments
    //   this.taskProgress.flag = 20;
    //   this.loading = true;
    //   this.loaderMessageLine1 = 'Assigning task...';

    //   this.http.post(`${environment.apiUrl}taskprogress/add`, this.taskProgress).subscribe({
    //     next: (res) => {
    //       this.resetForm();
    //            this.loading = false;
    //            this.loadTaskProgress();
    //       this.messageService.add({
    //         severity: 'success',
    //         summary: 'Success',
    //         detail: 'Task successfully assigned!'
    //       });
    //     },
    //     error: (err) => {
    //       this.resetForm();
    //           this.loading = false;
    //       this.messageService.add({
    //         severity: 'error',
    //         summary: 'Error',
    //         detail: 'Failed to assign task'
    //       });
    //     }
    //   });
    // }
    saveTaskProgress() {
        if (!this.taskProgress.userId || !this.taskProgress.startDate || !this.taskProgress.endDate || !this.taskProgress.targetValue) {
            // Set flag to 20 for new assignments) {
            this.taskProgress.flag = 20;
            this.messageService.add({
                severity: 'warn',
                summary: 'Missing fields',
                detail: 'Mandatory fields are missing. Please fill in all required fields.',
                life: 4000
            });
            return;
        }

        // Check for duplicate target for the same user and month
        // const newStart = new Date(this.taskProgress.startDate);
        // const newMonth = newStart.getMonth();
        // const newYear = newStart.getFullYear();

        // const duplicate = this.taskProgressList.some(tp =>
        //   tp.userId === this.taskProgress.userId &&
        //   tp.startDate &&
        //   new Date(tp.startDate).getMonth() === newMonth &&
        //   new Date(tp.startDate).getFullYear() === newYear
        // );

        // if (duplicate) {
        //   this.messageService.add({
        //     severity: 'error',
        //     summary: 'Duplicate Target',
        //     detail: 'This salesperson already has a target for the selected month.'
        //   });
        //   return;
        // }

        const newStart = new Date(this.taskProgress.startDate);
        const newEnd = new Date(this.taskProgress.endDate);
        if (newStart > newEnd) {
            this.messageService.add({
                severity: 'error',
                summary: 'Invalid Dates',
                detail: 'Start Date cannot be greater than End Date.',
                life: 4000
            });
            return;
        }
        const duplicate = this.taskProgressList.some(
            (tp) =>
                tp.userId === this.taskProgress.userId &&
                tp.startDate &&
                tp.endDate &&
                // Check for any overlap in date ranges
                new Date(tp.startDate) <= newEnd &&
                new Date(tp.endDate) >= newStart
        );

        if (duplicate) {
            this.messageService.add({
                severity: 'error',
                summary: 'Duplicate Target',
                detail: 'This salesperson already has a target that overlaps with the selected date range.',
                life: 4000
            });
            this.messageService.add({
                severity: 'warn',
                summary: 'Edit Existing Target',
                detail: 'If you want to customize the target for this salesperson, you can edit it directly in the table below.',
                life: 4000
            });
            return;
        }

        // Set flag to 20 for new assignments
        this.taskProgress.flag = 20;
        this.loaderService.show('Assigning task...', 'please wait');

        this.http
            .post(`${environment.apiUrl}taskprogress/add?company=${this.companyId}&division=${this.divisionId}`, this.taskProgress)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (res) => {
                    this.resetForm();
                    this.loaderService.hide();
                    this.loadTaskProgress();
                    this.messageService.add({
                        severity: 'success',
                        summary: 'Success',
                        detail: 'Task successfully assigned!',
                        life: 4000
                    });
                },
                error: (err) => {
                    this.resetForm();
                    this.loaderService.hide();
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to assign task',
                        life: 4000
                    });
                },
                complete: () => {
                    console.log('Task assignment POST request completed.');
                }
            });
    }
    resetForm() {
        console.log('resetForm called');

        this.taskProgress = {
            targetValue: null,
            userName: '',
            userId: null,
            status: 'ACTIVE',
            updatedAt: new Date().toISOString(),
            managerId: 1,
            startDate: '',
            endDate: '',
            comments: '',

            flag: 10,
            company: this.companyId,
            division: this.divisionId
        };
        this.selectedUser = '';
    }

    markRowAsUpdated(row: any) {
        row.flag = 30;
    }

    onStartDateBlur(row: any): void {
        console.log(`Start Date updated for ${row.userName}:`, row.startDate);
    }

    onEndDateBlur(row: any): void {
        console.log(`End Date updated for ${row.userName}:`, row.endDate);
    }

    //   updateIndividualTarget(member: any, newTarget: number) {
    //     const difference = newTarget - member.individualTarget;
    //     member.individualTarget = newTarget;
    //     this.task.targetValue += difference;
    //   }
    onGlobalFilter(table: Table, event: Event) {
        table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
    }
    toggleTaskForm() {
        this.showTaskForm = !this.showTaskForm;
    }

    toggleHeaderPanel() {
        this.headerPanelOpen = !this.headerPanelOpen;
    }

    toggleUserAssignmentsPanel() {
        this.userAssignmentsPanelOpen = !this.userAssignmentsPanelOpen;
    }

    goBack() {
        this.router.navigate(['/Orders1']);
    }
    ngOnDestroy(): void {
        // Signal all observables to complete and clean up subscriptions
        this.destroy$.next();
        this.destroy$.complete();
        console.log('TeamDetailsComponent destroyed');
    }
}

// import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
// import { CommonModule } from '@angular/common';
// import { DialogModule } from 'primeng/dialog';
// import { FormsModule } from '@angular/forms';
// import { ButtonModule } from 'primeng/button';
// import { InputTextModule } from 'primeng/inputtext';
// import { ToolbarModule } from 'primeng/toolbar';
// import { Table, TableModule } from 'primeng/table';
// import { Router, RouterModule } from '@angular/router';
// import { AutoCompleteModule } from 'primeng/autocomplete';
// import { CardModule } from 'primeng/card';
// import { ConfirmDialogModule } from 'primeng/confirmdialog';
// import { ContextMenuModule } from 'primeng/contextmenu';
// import { DividerModule } from 'primeng/divider';
// import { FieldsetModule } from 'primeng/fieldset';
// import { FluidModule } from 'primeng/fluid';
// import { IconFieldModule } from 'primeng/iconfield';
// import { InputIconModule } from 'primeng/inputicon';
// import { InputNumberModule } from 'primeng/inputnumber';
// import { MessageModule } from 'primeng/message';
// import { PanelModule } from 'primeng/panel';
// import { ProgressSpinnerModule } from 'primeng/progressspinner';
// import { RadioButtonModule } from 'primeng/radiobutton';
// import { RatingModule } from 'primeng/rating';
// import { RippleModule } from 'primeng/ripple';
// import { SelectModule } from 'primeng/select';
// import { SplitterModule } from 'primeng/splitter';
// import { TagModule } from 'primeng/tag';
// import { TextareaModule } from 'primeng/textarea';
// import { ToastModule } from 'primeng/toast';
// import { MessageService } from 'primeng/api';
// import { HttpClient } from '@angular/common/http';
// import { environment } from '../../environments/environment';
// import { InMemoryStorageService } from '../services/in-memory-storage.service';
// import { DatePickerModule } from 'primeng/datepicker';
// import { lastValueFrom, Subject, takeUntil } from 'rxjs';

// @Component({
//     selector: 'app-team-details',
//     imports: [
//         DatePickerModule,
//         ProgressSpinnerModule,
//         ToastModule,
//         FluidModule,
//         DividerModule,
//         MessageModule,
//         RouterModule,
//         FormsModule,
//         AutoCompleteModule,
//         CommonModule,
//         TableModule,
//         FieldsetModule,
//         PanelModule,
//         SplitterModule,
//         ButtonModule,
//         CardModule,
//         ContextMenuModule,
//         RippleModule,
//         ToolbarModule,
//         RatingModule,
//         InputTextModule,
//         TextareaModule,
//         SelectModule,
//         RadioButtonModule,
//         InputNumberModule,
//         DialogModule,
//         TagModule,
//         InputIconModule,
//         IconFieldModule,
//         ConfirmDialogModule
//     ],
//     templateUrl: './team-details.component.html',
//     styleUrls: ['./team-details.component.scss'],
//     providers: [MessageService]
// })
// export class TeamDetailsComponent implements OnInit, OnDestroy {
//     calendarValue: any;
//     @ViewChild('assignTaskButton') assignTaskButton!: ElementRef<HTMLButtonElement>;
//     task1: any = {
//     "taskId": 205,
//   "teamId": 1,
//   "targetId": 101,
//   "targetType": "Sales",
//   "targetValue": 5000.0,
//   "startDate": "2024-06-01",
//   "endDate": "2024-06-30",
//   "comment": "Monthly sales target"
// };
//     refreshOrders() {
//         this.loadTaskProgress();
//     }
//     loading: boolean = false;
//     loaderMessageLine1: string = '';
//     loaderMessageLine2: string = '';

//     taskProgressList: any[] = [];
//     headerPanelOpen: boolean = true;
//     userAssignmentsPanelOpen: boolean = true;
//     isEditingTargets: boolean = false;

//     selectedTask: any = null;
//     private destroy$ = new Subject<void>();
//     task: any = {
//         target_id: '',
//         teamId: '',
//         assignedBy: '',
//         targetType: '',
//         targetValue: 0,
//         startDate: '',
//         endDate: '',
//         comment: ''
//     };

//     allUsers: any[] = [];
//     selectedUser: any = null;
//     showTaskForm = true;

//     filteredUsers: any[] = [];
//     userNamesOnly: string[] = [];
//     filteredUserNames: string[] = [];
//     selectedUserName: string = '';

//     taskProgress = {
//         targetValue: null,
//         userName: '',
//         userId: null,
//         status: 'ACTIVE',
//         updatedAt: new Date().toISOString(),
//         managerId: 1,
//         startDate: '',
//         endDate: '',
//         comments: '',
//         task: {
//             taskId: 205
//         },
//         flag: 10,
//         company: '',
//         division: ''
//     };

//     constructor(
//         private router: Router,
//         private http: HttpClient,
//         private messageService: MessageService,
//         private inmemoryStorageService: InMemoryStorageService
//     ) {
//         this.fetchSalesPersonUsers();
//     }
//     divisionId: string = '';
//     companyId: string = '';
//     fetchSalesPersonUsers() {
//         //  const divisionId = this.inmemoryStorageService.get('division') || '';
//         this.http
//             .get<any[]>(`${environment.apiUrl}tasks/205?company=781&division=400`)
//             .pipe(takeUntil(this.destroy$))
//             .subscribe({
//                 next: (data) => {
//                     console.log('Fetched users by role group:', data);
//                     this.AddTask();

//                 },
//                 error: (err) => {
//                     console.error('Failed to fetch users by role group:', err);
//                       this.AddTask();
//                 },
//                 complete: () => {
//                     console.log('User fetch subscription completed.');
//                 }
//             });
//     }

//     AddTask() {

//         this.http
//             .post(`${environment.apiUrl}tasks/create`, this.task1)
//             .pipe(takeUntil(this.destroy$))
//             .subscribe({
//                 next: (res) => {
//                   console.log('Task created successfully:', res);
//                 },
//                 error: (err) => {
//                     console.log('Failed to create task:', err);
//                 },
//                 complete: () => {
//                     console.log('Task assignment POST request completed.');
//                 }
//             });

// }

//     ngOnInit() {



//         this.divisionId = this.inmemoryStorageService.get('division') || '';
//         this.companyId = this.inmemoryStorageService.get('company') || '';

//         this.fetchSalesPersonUsers();
//         const raw = this.inmemoryStorageService.get('allUsers');
//         let data = [];
//         this.taskProgress.division = this.divisionId;
//         this.taskProgress.company = this.companyId;
//         try {
//             data = typeof raw === 'string' ? JSON.parse(raw) : raw;
//         } catch (e) {
//             console.error('Parsing error:', e);
//         }

//         if (Array.isArray(data)) {
//             this.allUsers = data;
//             this.userNamesOnly = data.map((u) => u.userName);
//         }

//         Promise.all([this.loadTaskProgress()]).then(() => {});
//     }

//     filterUserNames(event: any) {
//         const query = event.query.toLowerCase();
//         this.filteredUserNames = this.userNamesOnly.filter((name) => name.toLowerCase().includes(query));
//     }

//     filterUsers(event: any) {
//         const query = event.query.toLowerCase();
//         this.filteredUsers = this.allUsers.filter((user) => user.userName.toLowerCase().includes(query));
//     }

//     onUserSelected(event: any) {
//         this.taskProgress.userName = event.value.userName;
//         console.log('✅ Selected user:', event.value);

//         this.taskProgress.userId = event.value.id;
//         console.log('✅ Selected user:', this.taskProgress);
//     }

//     loadTaskProgress(): Promise<void> {
//         this.loading = true;
//         this.loaderMessageLine1 = 'Loading team assignments...';
//         this.loaderMessageLine2 = '';

//         return new Promise((resolve) => {
//             this.http
//                 .get<any[]>(`${environment.apiUrl}taskprogress?company=${this.companyId}&division=${this.divisionId}`)
//                 .pipe(takeUntil(this.destroy$))
//                 .subscribe({
//                     next: (data) => {
//                         // Only add records where division matches current divisionId
//                         this.taskProgressList = data
//                             .filter((item) => item.division === this.divisionId)
//                             .map((item) => ({
//                                 ...item,
//                                 flag: 20,
//                                 startDate: item.startDate ? new Date(item.startDate) : null,
//                                 endDate: item.endDate ? new Date(item.endDate) : null
//                             }))
//                             .reverse();

//                         this.loading = false;
//                         resolve();
//                     },
//                     error: (err) => {
//                         this.loading = false;
//                         this.messageService.add({
//                             severity: 'error',
//                             summary: 'Error',
//                             detail: 'Failed to load task progress.'
//                         });
//                         resolve();
//                     },
//                     complete: () => {
//                         console.log('Task progress fetch completed.');
//                     }
//                 });
//         });
//     }
//     deleteTaskProgress(row: any) {
//         this.http
//             .delete(`${environment.apiUrl}taskprogress/${row.id}`)
//             .pipe(takeUntil(this.destroy$))
//             .subscribe({
//                 next: () => {
//                     // Remove the deleted row from the table
//                     this.taskProgressList = this.taskProgressList.filter((item) => item.id !== row.id);
//                     this.messageService.add({ severity: 'success', summary: 'Deleted', detail: 'Task progress deleted.' });
//                 },
//                 error: () => {
//                     this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to delete task progress.' });
//                 },
//                 complete: () => {
//                     console.log(`Delete request for taskProgress ID ${row.id} completed.`);
//                 }
//             });
//     }

//     submitTeam() {
//         this.loading = true;
//         this.loaderMessageLine1 = 'Updating task...';

//         // Only include rows with flag 30
//         const updatedMembers = this.taskProgressList.filter((member) => member.flag === 30);

//         const updateRequests = updatedMembers.map((member: any) => {
//             const progressPayload = {
//                 taskProgressId: member.taskProgressId,
//                 targetValue: member.targetValue,
//                 memberId: member.memberId,
//                 status: member.status, // Only send fields expected by API
//                 updatedAt: new Date().toISOString(),
//                 startDate: member.startDate,
//                 endDate: member.endDate,
//                 division: this.divisionId,
//                 company: this.companyId
//             };
//             return lastValueFrom(this.http.put(`${environment.apiUrl}taskprogress/${member.id}`, progressPayload));
//         });

//         Promise.all(updateRequests)
//             .then(() => {
//                 this.loading = false;
//                 this.messageService.add({
//                     severity: 'success',
//                     summary: 'Success',
//                     detail: 'Updated team targets successfully!'
//                 });
//             })
//             .catch(() => {
//                 this.loading = false;
//                 this.messageService.add({
//                     severity: 'error',
//                     summary: 'Error',
//                     detail: 'Failed to update some member progress.'
//                 });
//             });
//     }

//     saveTask() {
//         if (!this.task.target_id || !this.task.targetType || !this.task.targetValue || !this.task.startDate || !this.task.endDate || !this.task.teamId) {
//             this.messageService.add({
//                 severity: 'warn',
//                 summary: 'Missing fields',
//                 detail: 'Please fill in all required fields.'
//             });
//             return;
//         }
//     }

//     // saveTaskProgress() {
//     //   if (!this.taskProgress.userId || !this.taskProgress.task.taskId) {
//     //     this.taskProgress.flag = 20;
//     //     this.messageService.add({
//     //       severity: 'warn',
//     //       summary: 'Missing fields',
//     //       detail: 'User ID and Task ID are required.'
//     //     });
//     //     return;
//     //   }
//     //   // this.resetForm();
//     //   // Set flag to 20 for new assignments
//     //   this.taskProgress.flag = 20;
//     //   this.loading = true;
//     //   this.loaderMessageLine1 = 'Assigning task...';

//     //   this.http.post(`${environment.apiUrl}taskprogress/add`, this.taskProgress).subscribe({
//     //     next: (res) => {
//     //       this.resetForm();
//     //            this.loading = false;
//     //            this.loadTaskProgress();
//     //       this.messageService.add({
//     //         severity: 'success',
//     //         summary: 'Success',
//     //         detail: 'Task successfully assigned!'
//     //       });
//     //     },
//     //     error: (err) => {
//     //       this.resetForm();
//     //           this.loading = false;
//     //       this.messageService.add({
//     //         severity: 'error',
//     //         summary: 'Error',
//     //         detail: 'Failed to assign task'
//     //       });
//     //     }
//     //   });
//     // }
//     saveTaskProgress() {
//         if (!this.taskProgress.userId || !this.taskProgress.task.taskId || !this.taskProgress.startDate || !this.taskProgress.endDate || !this.taskProgress.targetValue) {
//             // Set flag to 20 for new assignments) {
//             this.taskProgress.flag = 20;
//             this.messageService.add({
//                 severity: 'warn',
//                 summary: 'Missing fields',
//                 detail: 'Mandatory fields are missing. Please fill in all required fields.'
//             });
//             return;
//         }

//         // Check for duplicate target for the same user and month
//         // const newStart = new Date(this.taskProgress.startDate);
//         // const newMonth = newStart.getMonth();
//         // const newYear = newStart.getFullYear();

//         // const duplicate = this.taskProgressList.some(tp =>
//         //   tp.userId === this.taskProgress.userId &&
//         //   tp.startDate &&
//         //   new Date(tp.startDate).getMonth() === newMonth &&
//         //   new Date(tp.startDate).getFullYear() === newYear
//         // );

//         // if (duplicate) {
//         //   this.messageService.add({
//         //     severity: 'error',
//         //     summary: 'Duplicate Target',
//         //     detail: 'This salesperson already has a target for the selected month.'
//         //   });
//         //   return;
//         // }

//         const newStart = new Date(this.taskProgress.startDate);
//         const newEnd = new Date(this.taskProgress.endDate);
//         if (newStart > newEnd) {
//             this.messageService.add({
//                 severity: 'error',
//                 summary: 'Invalid Dates',
//                 detail: 'Start Date cannot be greater than End Date.'
//             });
//             return;
//         }
//         const duplicate = this.taskProgressList.some(
//             (tp) =>
//                 tp.userId === this.taskProgress.userId &&
//                 tp.startDate &&
//                 tp.endDate &&
//                 // Check for any overlap in date ranges
//                 new Date(tp.startDate) <= newEnd &&
//                 new Date(tp.endDate) >= newStart
//         );

//         if (duplicate) {
//             this.messageService.add({
//                 severity: 'error',
//                 summary: 'Duplicate Target',
//                 detail: 'This salesperson already has a target that overlaps with the selected date range.'
//             });
//             this.messageService.add({
//                 severity: 'warn',
//                 summary: 'Edit Existing Target',
//                 detail: 'If you want to customize the target for this salesperson, you can edit it directly in the table below.'
//             });
//             return;
//         }

//         // Set flag to 20 for new assignments
//         this.taskProgress.flag = 20;
//         this.loading = true;
//         this.loaderMessageLine1 = 'Assigning task...';

//         this.http
//             .post(`${environment.apiUrl}taskprogress/add?company=${this.companyId}&division=${this.divisionId}`, this.taskProgress)
//             .pipe(takeUntil(this.destroy$))
//             .subscribe({
//                 next: (res) => {
//                     this.resetForm();
//                     this.loading = false;
//                     this.loadTaskProgress();
//                     this.messageService.add({
//                         severity: 'success',
//                         summary: 'Success',
//                         detail: 'Task successfully assigned!'
//                     });
//                 },
//                 error: (err) => {
//                     this.resetForm();
//                     this.loading = false;
//                     this.messageService.add({
//                         severity: 'error',
//                         summary: 'Error',
//                         detail: 'Failed to assign task'
//                     });
//                 },
//                 complete: () => {
//                     console.log('Task assignment POST request completed.');
//                 }
//             });
//     }
//     resetForm() {
//         console.log('resetForm called');

//         this.taskProgress = {
//             targetValue: null,
//             userName: '',
//             userId: null,
//             status: 'ACTIVE',
//             updatedAt: new Date().toISOString(),
//             managerId: 1,
//             startDate: '',
//             endDate: '',
//             comments: '',
//             task: {
//                 taskId: 205
//             },
//             flag: 10,
//             company: this.companyId,
//             division: this.divisionId
//         };
//         this.selectedUser = '';
//     }

//     markRowAsUpdated(row: any) {
//         row.flag = 30;
//     }

//     onStartDateBlur(row: any): void {
//         console.log(`Start Date updated for ${row.userName}:`, row.startDate);
//     }

//     onEndDateBlur(row: any): void {
//         console.log(`End Date updated for ${row.userName}:`, row.endDate);
//     }

//     //   updateIndividualTarget(member: any, newTarget: number) {
//     //     const difference = newTarget - member.individualTarget;
//     //     member.individualTarget = newTarget;
//     //     this.task.targetValue += difference;
//     //   }
//     onGlobalFilter(table: Table, event: Event) {
//         table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
//     }
//     toggleTaskForm() {
//         this.showTaskForm = !this.showTaskForm;
//     }

//     toggleHeaderPanel() {
//         this.headerPanelOpen = !this.headerPanelOpen;
//     }

//     toggleUserAssignmentsPanel() {
//         this.userAssignmentsPanelOpen = !this.userAssignmentsPanelOpen;
//     }

//     goBack() {
//         this.router.navigate(['/Orders']);
//     }
//     ngOnDestroy(): void {
//         // Signal all observables to complete and clean up subscriptions
//         this.destroy$.next();
//         this.destroy$.complete();
//         console.log('TeamDetailsComponent destroyed');
//     }
// }
